<template src="../../templates/dhs/manualReport.html"></template>

<script>
	import ManualReportCollection from '@/collections/manualReportCollection'
	import ManualModel from '@/components/dhs/ManualModel'
	
	export default {
		name: "ManualReport",
		props: ['type'],
		watch: {
			'$route': 'initialQuery'
		},
		components: {
			ManualModel
		},
		data() {
			return {
				manualReportCollection: new ManualReportCollection(),
				isDataLoading: false,
				rowObject: {
					"overflow-y": "scroll",
					height: this.getScrollableHeight(),
					"max-height": this.getScrollableHeight()
				},
				paginatedJobCollections: [],
				tableHeader: [
					{
						key: 'title',
						label: 'Title',
						sortable: true,
						thStyle: {
							border: '2px solid white'
						}
					},
					{
						key: 'from',
						label: 'From',
						sortable: true,
						thStyle: {
							border: '2px solid white',
							width: '305px'
						}
					},
					{
						key: 'to',
						label: 'To',
						sortable: true,
						thStyle: {
							border: '2px solid white'
						}
					},
					{
						key: 'action',
						label: 'Action',
						sortable: true,
						thStyle: {
							border: '2px solid white'
						}
					}
				]
			}
		},
		created() {
			this.initialQuery();
		},
		methods: {
			initialQuery() {
				let url = this.manualReportCollection.getRoute('fetch') + this.type;

				this.$http.get(url, {
					headers: {"Bearer": localStorage.getItem("jwt")}
				}).then((res) => {

					this.manualReportCollection.models = res.data.data;
					this.isDataLoading = false;

				}).catch(function (error) {
					console.log(error);
				});
			},
			getScrollableHeight() {
				// console.log('window.innerHeight');
				// console.log(window.innerHeight);
				let offset = 0;
				if(window.innerHeight > 900) {
					offset = 240;
				}
				else if(800 < window.innerHeight < 900) {
					offset = 260;
				}
				else if(700 < window.innerHeight < 800) {
					offset = 280;
				}
				else if(600 < window.innerHeight < 700) {
					offset = 290;
				}

				return window.innerHeight - offset + "px";
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/dhs/ManualReport.vue